


































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SubmitForm from "@/components/Forms/SubmitForm.vue";
import { Observer } from "mobx-vue";

@Observer
@Component({
  components: { SubmitForm }
})
export default class SimpleDialogForm extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "CANCEL" }) negativeButtonText?: string;
  @Prop({ default: "OK" }) positiveButtonText?: string;
  @Prop({ default: "" }) deleteButtonText?: string;
  @Prop({ default: "500" }) width?: string;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: "" }) dataCy?: string;
  @Prop({ default: false }) positiveButtonDisabled?: boolean;

  submitRequest() {
    this.$emit("submitRequest");
  }

  deleteShownItem() {
    this.$emit("deleteShownItem");
  }

  close() {
    this.$emit("closeDialog");
  }
}
